// Centralized app info used in footer / About dialogs.
// Update APP_VERSION and APP_BUILD_DATE on each significant release.

export const APP_NAME = "AVI Segurança";
export const APP_VERSION = "1.0.0";
export const APP_BUILD_DATE = "2026-05-13";
export const APP_DEVELOPER = "Hugo Andrade";
export const APP_COMPANY = "Dark Horse Tecnologia";
export const APP_DEVELOPER_TAG = "DESENVOLVIDO POR DARK HORSE TECNOLOGIA ®";
export const APP_DEVELOPER_LOGO = "/assets/dark_horse_logo.png";
export const APP_DESCRIPTION =
  "Aplicativo oficial dos colaboradores AVI Segurança — acesso a contracheques, informes de rendimentos, avisos internos, treinamentos certificados, comprovantes de admissão e férias, com assinatura digital com validade jurídica.";
export const APP_COMPANY_DESCRIPTION =
  "A Dark Horse Tecnologia é uma empresa focada no desenvolvimento de soluções tecnológicas inteligentes, unindo inovação, automação e praticidade para transformar operações do dia a dia em processos mais modernos, eficientes e seguros.\n\nCom atuação voltada para criação de sistemas, aplicativos, plataformas digitais e soluções personalizadas, a empresa busca atender negócios que desejam evoluir tecnologicamente, otimizar a gestão e oferecer uma experiência mais profissional aos seus clientes e colaboradores.";
export const APP_SUPPORT_EMAIL = "hugoansi@gmail.com";
export const APP_CLIENT_COMPANY = "AVI SERVIÇOS DE SEGURANÇA LTDA";
